const BRANDS = [
  "MERCEDES-BENZ",
  "BMW",
  "AUDI",
  "PORSCHE",
  "RANGE ROVER",
  "VOLVO",
  "TOGG",
  "MASERATI",
];

export default function Marquee() {
  const loop = [...BRANDS, ...BRANDS];
  return (
    <section data-testid="brand-marquee" className="relative border-y border-white/10 bg-black">
      <p className="container-x pt-7 text-center font-oswald text-[11px] uppercase tracking-[0.3em] text-neutral-600">
        Kocaeli'nin premium markalarına güvenle hizmet
      </p>
      <div className="relative overflow-hidden py-6">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-28 bg-gradient-to-r from-black to-transparent sm:w-40" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-28 bg-gradient-to-l from-black to-transparent sm:w-40" />
        <div className="marquee-track animate-marquee items-center">
          {loop.map((brand, i) => (
            <div key={i} className="flex shrink-0 items-center gap-8 px-8 sm:gap-12 sm:px-12">
              <span className="ghost-text whitespace-nowrap font-oswald text-3xl font-bold tracking-wide sm:text-5xl">
                {brand}
              </span>
              <span className="h-2 w-2 rotate-45 bg-gold/50" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
